import { render } from "./PageNotFound.vue?vue&type=template&id=74a710c4&scoped=true"
const script = {}

import "./PageNotFound.vue?vue&type=style&index=0&id=74a710c4&scoped=true&lang=scss"

import exportComponent from "D:\\web\\OpenServer\\domains\\lembergflowers\\lembergflowers\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a710c4"]])

export default __exports__